import { render, staticRenderFns } from "./newDetail.vue?vue&type=template&id=26c6d8d6&scoped=true&"
import script from "./newDetail.vue?vue&type=script&lang=js&"
export * from "./newDetail.vue?vue&type=script&lang=js&"
import style0 from "./newDetail.vue?vue&type=style&index=0&id=26c6d8d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c6d8d6",
  null
  
)

export default component.exports